import React from 'react';

import { observer } from 'mobx-react';
import NotificationsNoneRoundedIcon from '@mui/icons-material/NotificationsNoneRounded';
import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded';
import MailOutlineRoundedIcon from '@mui/icons-material/MailOutlineRounded';
import TextsmsOutlinedIcon from '@mui/icons-material/TextsmsOutlined';

import classes from './NgzCommunicationModal.module.scss';
import { angularizeWithProviders } from '../../../shared/providers';
import { communicationModalStore } from '../../stores/communicationModalStore';
import { SendMessageWayTypes, SEND_MESSAGE_WAY } from '../../constants/SEND_MESSAGE_WAY';
import { CommunicationForm } from './CommunicationForm/CommunicationForm';
import { SendingMessageModal } from './SendingMessageModal/SendingMessageModal';
import { SuccessSentMessageModal } from './SuccessSentMessageModal/SuccessSentMessageModal';
import { ErrorSentMessageModal } from './ErrorSentMessageModal/ErrorSentMessageModal';
import { LbBigModal } from '../../../shared/components/modals';
import {
  LbTabPanel,
  LbTabs,
  LbToggleTabsList,
  TabsConfig,
} from '../../../shared/components/tabs';

const NgzCommunicationModal = observer(() => {
  const { isModalOpen, via, customersCount, availableChannels, setVia } =
    communicationModalStore;

  const handleTabChange = (newActiveTab: SendMessageWayTypes) => {
    setVia(newActiveTab);
  };

  const isChannelHidden = (channel: SendMessageWayTypes) =>
    !availableChannels.includes(channel);

  const tabsConfig: TabsConfig[] = [
    {
      label: 'Push Notification',
      value: SEND_MESSAGE_WAY.PUSH,
      icon: <NotificationsNoneRoundedIcon fontSize="medium" />,
      panel: <CommunicationForm withSubject />,
      hide: isChannelHidden(SEND_MESSAGE_WAY.PUSH),
    },
    {
      label: 'Chat Message',
      value: SEND_MESSAGE_WAY.CHAT,
      icon: <ChatBubbleOutlineRoundedIcon fontSize="medium" />,
      panel: <CommunicationForm uploadFilesEnabled />,
      hide: isChannelHidden(SEND_MESSAGE_WAY.CHAT),
    },
    {
      label: 'Email Letter',
      value: SEND_MESSAGE_WAY.EMAIL,
      icon: <MailOutlineRoundedIcon fontSize="medium" />,
      panel: <CommunicationForm withSubject />,
      hide: isChannelHidden(SEND_MESSAGE_WAY.EMAIL),
    },
    {
      label: 'SMS Message',
      value: SEND_MESSAGE_WAY.SMS,
      icon: <TextsmsOutlinedIcon fontSize="medium" />,
      panel: <CommunicationForm />,
      hide: isChannelHidden(SEND_MESSAGE_WAY.SMS),
    },
  ];

  return (
    <>
      <LbBigModal
        open={isModalOpen}
        title={`Send Message to ${customersCount} Customers`}
        renderButtonRow={null}
      >
        <LbTabs value={via} onValueChange={handleTabChange}>
          <LbToggleTabsList
            tabsConfig={tabsConfig}
            fullWidth
            className={classes.tabsList}
          />
          <LbTabPanel tabsConfig={tabsConfig} />
        </LbTabs>
      </LbBigModal>
      <SendingMessageModal />
      <SuccessSentMessageModal />
      <ErrorSentMessageModal />
    </>
  );
});

angularizeWithProviders(NgzCommunicationModal, 'ngzCommunicationModal', {});

export { NgzCommunicationModal };
